import { Bus, Car, House } from 'lucide-vue-next'
import type { IStrahovanieService } from './types'

export const STRAHOVANIE_FRAME_BASE_URL = 'https://strahovanie.kg/frame'

export const STRAHOVANIE_FRAME_PARAMS = {
  ref: 'bankskg',
  color: '2563eb',
  bg: 'f3f4f6'
}

// The cross-origin frame can't report its height, so heights are measured by hand
// on the first form step: the widest locale at 360px for mobile, 766px for desktop.
// The frame caps its form at ~847px and scrolls it unless `height` is passed, so
// `height` is set to the tallest (mobile) value to keep the form uncapped.
// osgor (employer) and travel (outboard) frames are announced but not live yet
export const STRAHOVANIE_SERVICES: IStrahovanieService[] = [
  {
    id: 'osago',
    insuranceType: 'osago',
    label: 'widget.strahovanie_frame.osago',
    hint: 'widget.strahovanie_frame.osago_hint',
    icon: Car,
    path: 'osago',
    frameClass: 'h-[1112px] sm:h-[929px]',
    frameMaxHeight: 1112
  },
  {
    id: 'oszh',
    insuranceType: 'property',
    label: 'widget.strahovanie_frame.oszh',
    hint: 'widget.strahovanie_frame.oszh_hint',
    icon: House,
    path: 'oszh',
    frameClass: 'h-[1350px] sm:h-[1071px]',
    frameMaxHeight: 1350
  },
  {
    id: 'osgop',
    insuranceType: 'passengers',
    label: 'widget.strahovanie_frame.osgop',
    hint: 'widget.strahovanie_frame.osgop_hint',
    icon: Bus,
    path: 'passengers',
    frameClass: 'h-[950px] sm:h-[839px]',
    frameMaxHeight: 950
  }
]
